import { EmptyTrashBin } from '..';
import * as storymapStoreModule from '../../../store';

export const createEmptyTrashBinCommand = async () => {
    const store = storymapStoreModule.useStorymapStore();

    return new EmptyTrashBin(store.state.id);
};
